import { render, staticRenderFns } from "./CreateProcess.vue?vue&type=template&id=fae3489c&scoped=true&"
import script from "./CreateProcess.vue?vue&type=script&lang=js&"
export * from "./CreateProcess.vue?vue&type=script&lang=js&"
import style0 from "./CreateProcess.vue?vue&type=style&index=0&id=fae3489c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3489c",
  null
  
)

export default component.exports